let _ = t => t,
  _t;
import { createGlobalStyle } from 'styled-components';
import { useTheme, isDarkTheme } from 'foundations-theming/utils';

// trellis-dark maps border-inverse-default and border-inverse-disabled to #2D061B
// (next-magenta-1500) instead of neutral white, and fill-inverse-hover to #FFFFFF
// (full white) instead of a subtle overlay. Both tokens are shared across multiple
// components so global token overrides cause side effects. Scope fixes to
// [data-button-use="secondary-ghost"] via CSS instead.
import { jsx as _jsx } from "react/jsx-runtime";
const StyledGlobalButtonOverrides = createGlobalStyle(_t || (_t = _`
  [data-button-use='secondary-ghost'] {
    color: ${0} !important;
  }
  [data-button-use='secondary-ghost'][aria-disabled='true'] {
    color: ${0} !important;
    background-color: ${0} !important;
  }
  [data-button-use='secondary-ghost']:hover:not([aria-disabled='true']) {
    background-color: ${0} !important;
  }
  ${0}
`), ({
  $color
}) => $color, ({
  $disabledColor
}) => $disabledColor, ({
  $disabledBg
}) => $disabledBg, ({
  $hoverBg
}) => $hoverBg, ({
  $isDarkMode
}) => $isDarkMode && `
      [data-button-use='secondary-ghost']:not([aria-disabled='true']) {
        border-color: #fff !important;
      }
      [data-button-use='secondary-ghost'][aria-disabled='true'] {
        border-color: rgba(255, 255, 255, 0.3) !important;
      }
    `);
export const GlobalButtonStyles = () => {
  const theme = useTheme();
  const isDarkMode = isDarkTheme(theme);
  return /*#__PURE__*/_jsx(StyledGlobalButtonOverrides, {
    $color: theme.color['text-core-default'],
    $disabledColor: theme.color['text-core-disabled'],
    $disabledBg: isDarkMode ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)',
    $hoverBg: isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)',
    $isDarkMode: isDarkMode
  });
};